import React from "react";

const Error = () => {
  return <div>Oops! This page is not available.</div>;
};

export default Error;
